var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebookSocialMediaSvgrepoCom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M469.333,0H42.667C19.14,0,0,19.14,0,42.667v426.667C0,492.86,19.14,512,42.667,512h196.267V341.333h-68.267v-102.4 h68.267v-42.667c0-57.489,44.672-106.197,101.7-110.908l94.566-0.026v102.4h-85.333c-4.702,0-8.533,3.831-8.533,8.533v42.667 h85.333v102.4h-85.333V512h128C492.86,512,512,492.86,512,469.333V42.667C512,19.14,492.86,0,469.333,0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.6,256h-85.333v-59.733c0-14.114,11.486-25.6,25.6-25.6h68.267V102.4h-76.8C293.794,106.351,256,147.593,256,196.267 V256h-68.267v68.267H256V512h68.267V324.267H409.6V256z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookSocialMediaSvgrepoCom);
export default __webpack_public_path__ + "static/media/facebook-social-media-svgrepo-com.e08711893742520dfcbcd06191f86ff0.svg";
export { ForwardRef as ReactComponent };